<span
  [matTooltip]="disabled ? disabledTooltip : null"
  [matTooltipPosition]="'above'"
>
  <button
    class="btn btn-link chart-icon-btn"
    [ngClass]="{ 'other-reports-btn': type == 'otherReports' }"
    [disabled]="disabled || (type == 'otherReports' && !url)"
    [title]="
      !(disabled || (type == 'otherReports' && !url)) ? 'Go to ' + btnName : ''
    "
    (mouseenter)="highlighted = true"
    (mouseleave)="highlighted = false"
    (click)="selectBtn(type)"
  >
    <img
      [src]="
        partialImagePath +
        imgName +
        (selected || highlighted
          ? '_active'
          : disabled || (type == 'otherReports' && !url)
          ? '_disabled'
          : '') +
        '.svg'
      "
      class="chart-icon-img"
    />
    <p
      class="btn-text"
      [ngClass]="
        selected || highlighted
          ? 'active-text'
          : disabled || (type == 'otherReports' && !url)
          ? 'disabled-text'
          : ''
      "
    >
      {{ btnName }}
    </p>
  </button>
</span>
